import { styled } from 'styled-components';

export const DashboardHeading = styled.h1`
  font-family: 'Noto Sans', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.2px;
  color: #242527;
  margin-top: 24px;
`;

export const DashboardDescription = styled.p`
  font-family: 'Noto Sans', sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: #000;
  white-space: pre-line;
`;

export const BlueLink = styled.a`
  color: #42abe9;
`;

export const ValueContainer = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 24px;
`;

export const ValueText = styled.span`
  font-weight: bold;
  font-size: 36px;
  line-height: 48px;
  letter-spacing: -0.6px;
  color: ${({ theme }) => theme.colors.black20};
`;

export const SubValue = styled.span`
  font-weight: bold;
  font-size: 20px;
  line-height: 48px;
  color: ${({ theme }) => theme.colors.black20};
`;

export const SubHeader = styled.h3`
  font-weight: bold;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.blackText};
  margin: 0;
`;

export const Title = styled.h2`
  margin: 0;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.black70};
`;
